import styled from 'styled-components';

export const Container = styled.div`
    text-align: center;
    margin-top: 300px;
    max-height: 200px;    
`;

export const Title = styled.h1`
    text-align: center;
    font-size: 5rem;
    font-family: sans-serif;
    color: #333;
`;

export const Button = styled.button`
    color: #fff;
    background: #000;
    cursor: pointer; 
    padding: 4px 6px;   
`;

export const Input = styled.input`
    padding: 4px 8px;
`;

export const ErrorMsg = styled.span`
    display: block;
    font-size: 0.65rem;
    color: red;
    font-weight: 600;
    margin-top: 1rem;
`;

